"use client"

import { Box, Button, Checkbox, Flex, FormLabel, Heading, HStack, Skeleton, useToast, Text } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router-dom"
import { useSave } from "./service"
import type { FormValues } from "./model"
import { ModalPainel } from "@/components/ModalPainel"
import { Paper } from "@/components/Paper"
import { useState, useEffect } from "react"
import { TitleModalPainel } from "@/components/ModalPainel/TitlePainel"
import { FaFolder, FaChevronRight, FaChevronDown, FaCheck, FaTimes, FaKey, FaCheckDouble } from "react-icons/fa"
import axios from "axios"
import { api } from "@/services/api"
import { useQueryListToSelect } from "@/services/adapters/queryListToSelect"
import { MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md"
import ModalRetorno from "@/modules/Portaria/components/ModalRetorno"

export function UsuarioPermissionCreate() {
  const navigate = useNavigate()


  const { id: userSelected } = useParams()
  const nav = useNavigate()

  const [menuSelect, setMenuSelect] = useState<any[]>([])
  const [rotinaSelect, setRotinaSelect] = useState<any[]>([])
  const [rotinasSuccessCreated, setRotinaSuccessCreated] = useState<any[]>([])
  const [expandedMenus, setExpandedMenus] = useState<Record<string, boolean>>({})
  const [mensagemErro, setMensagemErro] = useState<string | null>(null);
  const [mensagemSucesso, setMensagemSucesso] = useState<string | null>(null);

  const { list: listMenu } = useQueryListToSelect("menu")
  const { list: listRotina } = useQueryListToSelect("rotina")



  const submitPermissao = async () => {
    try {
      await axios
        .all(
          rotinaSelect?.map((rotina) =>
            api.post("permissao", { ativo: true, rotina: rotina?.value, usuario: userSelected }),
          ),
        )
        .then(
          axios.spread((...allData) => {
            allData?.map((el) => setRotinaSuccessCreated((rs) => [...rs, el?.data]))
            setMensagemSucesso('Permissões adicionadas com sucesso');

            return
          }),
        )
        .catch((error) => {
          setMensagemErro('Erro ao criar Permissões.');
        })
    } catch (error: any) {
      setMensagemErro(JSON.stringify(error?.response?.data?.mensagem || "Erro ao realizar operação"));
    }
  }

  const toggleMenu = (menuId: string) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }))
  }

  const isMenuPartiallySelected = (menuId: string) => {
    const menuRoutines = listRotina?.filter((r: any) => r?.menu === menuId) || []
    const someSelected = menuRoutines.some((r: any) => rotinaSelect?.some((selected) => selected?.value === r?.value))
    const allSelected =
      menuRoutines.length > 0 &&
      menuRoutines.every((r: any) => rotinaSelect?.some((selected) => selected?.value === r?.value))
    return someSelected && !allSelected
  }

  const handleMenuSelect = (menu: any) => {
    const menuRoutines = listRotina?.filter((r: any) => r?.menu === menu?.value) || []

    const allSelected =
      menuRoutines.length > 0 &&
      menuRoutines.every((r: any) => rotinaSelect?.some((selected) => selected?.value === r?.value))

    if (allSelected) {

      setRotinaSelect((prev) => prev.filter((item) => !menuRoutines.some((r:any) => r.value === item.value)))
    } else {

      const newRoutines = menuRoutines.filter(
        (r: any) => !rotinaSelect?.some((selected) => selected?.value === r?.value),
      )
      setRotinaSelect((prev) => [...prev, ...newRoutines])
    }
  }


  const isMenuChecked = (menuId: string) => {
    const menuRoutines = listRotina?.filter((r: any) => r?.menu === menuId) || []
    return (
      menuRoutines.length > 0 &&
      menuRoutines.every((r: any) => rotinaSelect?.some((selected) => selected?.value === r?.value))
    )
  }


  const onCheckRotina = (item: { id: number; value: string; label: string; menu: string }) => {
    const isChecked = rotinaSelect?.some((element) => element?.value === item?.value)

    if (isChecked) {
      setRotinaSelect((prev) => prev?.filter((el) => el?.value !== item?.value))
    } else {
      setRotinaSelect((prev) => [...prev, item])
    }
  }


  useEffect(() => {
    if (listMenu && listMenu.length > 0) {
      const initialExpandedState: Record<string, boolean> = {}
      listMenu.forEach((menu: any) => {
        initialExpandedState[menu.value] = true
      })
      setExpandedMenus(initialExpandedState)
    }
  }, [listMenu])

  const selectAllPermissions = () => {

    if (listRotina && listRotina.length === rotinaSelect.length && 
        listRotina.every((r: any) => rotinaSelect.some(selected => selected.value === r.value))) {
      setRotinaSelect([])
    } else {

      setRotinaSelect([...listRotina])
    }
  }

  const areAllPermissionsSelected = () => {
    return listRotina && 
           rotinaSelect.length === listRotina.length && 
           listRotina.every((r: any) => rotinaSelect.some(selected => selected.value === r.value))
  }

  return (
    <>
    <ModalPainel>
      <Box p={5}>
        <Paper w={"full"} bg={"white"} shadow={"md"} py={4} display={"grid"} gap={4} px={4} rounded={"xl"}  borderTopLeftRadius="2xl"
            borderTopRightRadius="2xl">
        <Flex
            alignItems="center"
            justifyContent="space-between"
            bg="#117baa"
            color="white"
            p={3}
            px={1}
            mt={-4}
            borderTopLeftRadius="xl"
            borderTopRightRadius="xl"
            mx={-4}
            mb={4}
          >
            
             <HStack w={'100%'} pl={2}  justify={'space-around'}>
                <HStack>
                  <Box as={FaKey} color={'#117baa'} boxSize={6} p={1} bg="#DBF2FB" rounded="full" />
                  <Heading size="md" fontWeight={'bold'}>Gerenciar Permissões</Heading>
                </HStack>
                <Flex justifyItems={'flex-end'} justifyContent='flex-end' alignItems="center" mb={3} px={2}>
                  <Box
                    boxSize={6}
                    as={areAllPermissionsSelected() ? MdOutlineCheckBox  : MdOutlineCheckBoxOutlineBlank}
                    onClick={selectAllPermissions}
                  >
                  </Box>
                  <Text>Todos</Text>
              </Flex>
            </HStack>
          </Flex>

          {!listMenu ? (
            <Skeleton w={"full"} h={12} />
          ) : (
            <Box  overflow="hidden" maxH="65vh" overflowY="auto" >

              <Box p={2}>
                {listMenu?.map((menu: any) => {
                  const menuRoutines = listRotina?.filter((r: any) => r?.menu === menu?.value) || []
                  const isExpanded = expandedMenus[menu.value]

                  return (
                    <Box key={menu.value} mb={2} borderWidth="1px" borderRadius="md" overflow="hidden">
                      <Flex
                        p={2}
                        alignItems="center"
                        bg={isMenuPartiallySelected(menu.value) ? "gray.100" : "white"}
                        _hover={{ bg: "gray.50" }}
                        cursor="pointer"
                        onClick={() => toggleMenu(menu.value)}
                      >
                        <Checkbox
                          mr={2}
                          isChecked={isMenuChecked(menu.value)}
                          isIndeterminate={isMenuPartiallySelected(menu.value)}
                          onChange={(e) => {
                            e.stopPropagation()
                            handleMenuSelect(menu)
                          }}
                          colorScheme="blue"
                        />

                        <Flex alignItems="center" flex={1} onClick={(e) => e.stopPropagation()}>
                          <Box mr={2}>
                            <FaFolder color="#4A5568" />
                          </Box>
                          <Box onClick={() => toggleMenu(menu.value)} fontWeight="500">{menu?.label}</Box>
                        </Flex>

                        <Box>
                          {isExpanded ? (
                            <FaChevronDown size={12} color="#4A5568" />
                          ) : (
                            <FaChevronRight size={12} color="#4A5568" />
                          )}
                        </Box>
                      </Flex>

                      {/* Routines */}
                      {isExpanded && (
                        <Box pl={10} pr={4} pb={2} pt={1}>
                          {menuRoutines.map((rotina: any) => (
                            <Flex
                              key={rotina.value}
                              p={2}
                              alignItems="center"
                              _hover={{ bg: "gray.50" }}
                              borderRadius="md"
                              cursor="pointer"
                              onClick={() => onCheckRotina(rotina)}
                            >
                              <Checkbox
                                mr={2}
                                isChecked={rotinaSelect?.some((r) => r?.value === rotina?.value)}
                                onChange={(e) => {
                                  e.stopPropagation()
                                  onCheckRotina(rotina)
                                }}
                                colorScheme="blue"
                              />

                              <Flex alignItems="center">
                                <Box mr={2}>
                                  <FaFolder size={12} color="#718096" />
                                </Box>
                                <Box fontSize="sm">{rotina?.label}</Box>
                              </Flex>
                            </Flex>
                          ))}
                        </Box>
                      )}
                    </Box>
                  )
                })}
              </Box>
            </Box>
          )}

          <Flex py={3} justifyContent="space-between" borderTopWidth="1px" mt={2} pt={2}>
            <Button size="sm" variant={'outline'} onClick={() => navigate("..")} colorScheme="gray" leftIcon={<FaTimes />}>
              Cancelar
            </Button>

            <Button
              size="sm"
              onClick={submitPermissao}
              bg={'#117baa'}
              leftIcon={<FaCheck />}
              isDisabled={rotinaSelect.length === 0}
              color={'white'}
            >
              Salvar Permissões
            </Button>
          </Flex>
        </Paper>
      </Box>
    </ModalPainel>
       {(mensagemErro || mensagemSucesso) && (
        <ModalRetorno
          isOpen={true}
          onClose={() => {
            setMensagemErro(null);
            setMensagemSucesso(null);
            nav(-1)
          }}
          mensagem={mensagemErro || mensagemSucesso || ''}
          tipo={mensagemErro ? 'erro' : 'sucesso'}
        />
      )}
      </>
  )
}
